<template>
    <form
        method="post"
        autocomplete="off"
        enctype="multipart/form-data"
        @submit.prevent="handleSubmit"
    >
        <div class="row pt-2">
            <div class="col-md-6">
                <div class="form-group">
                    <label
                        class="form-control-label text-muted"
                        for="first_name"
                        >First Name</label
                    >
                    <input
                        type="text"
                        v-model="form.first_name"
                        id="firstName"
                        name="firstName"
                        class="form-control"
                        :class="{
                            'is-invalid':
                                submitted && v$.form.first_name.$error,
                        }"
                    />
                    <span class="text-danger" v-if="v$.form.first_name.$errors">
                        {{ v$.form.first_name.$errors[0]?.$message }}
                    </span>
                </div>
            </div>
            <div class="col-md-6">
                <div class="form-group">
                    <label class="form-control-label text-muted" for="last_name"
                        >Last Name</label
                    >
                    <input
                        type="text"
                        v-model="form.last_name"
                        id="lastName"
                        name="lastName"
                        class="form-control"
                        :class="{
                            'is-invalid': submitted && v$.form.last_name.$error,
                        }"
                    />
                    <span class="text-danger" v-if="v$.form.last_name.$errors">
                        {{ v$.form.last_name.$errors[0]?.$message }}
                    </span>
                </div>
            </div>
        </div>
        <div class="row pt-2">
            <div class="col-md-6">
                <div class="form-group">
                    <label class="form-control-label text-muted" for="email"
                        >Email</label
                    >
                    <input
                        type="text"
                        v-model="form.email"
                        id="email"
                        name="email"
                        class="form-control"
                        :class="{
                            'is-invalid': submitted && v$.form.email.$error,
                        }"
                    />
                    <span class="text-danger" v-if="v$.form.email.$errors">
                        {{ v$.form.email.$errors[0]?.$message }}
                    </span>
                </div>
            </div>
            <div class="col-md-6">
                <div class="form-group">
                    <label class="form-control-label text-muted" for="phone"
                        >Phone</label
                    >
                    <input
                        type="text"
                        v-model="form.phone"
                        id="phone"
                        name="phone"
                        v-mask="'000-000-0000'"
                        class="form-control"
                        :class="{
                            'is-invalid': submitted && v$.form.phone.$error,
                        }"
                    />
                    <span class="text-danger" v-if="v$.form.phone.$errors">
                        {{ v$.form.phone.$errors[0]?.$message }}
                    </span>
                </div>
            </div>
        </div>
        <div class="row pt-2">
            <div class="col-md-12">
                <div class="form-group">
                    <label class="form-control-label text-muted" for="email"
                        >Role</label
                    >
                    <select
                        name="state"
                        class="form-control"
                        v-model="form.role"
                        placeholder="State"
                        required
                    >
                        <option v-if="['super_admin'].includes(user.role.name)" value="super_admin">Super Admin</option>
                        <option v-if="['super_admin'].includes(user.role.name)" value="quote_approver">Quote Approver</option>
                        <option value="sales_reps">Sales Reps</option>
                        <option v-if="['super_admin'].includes(user.role.name)" value="sales_admin">Sales Admin</option>
                    </select>
                </div>
            </div>
        </div>
        <!-- <div class="row pt-2">
            <div class="col-md-12">
                <div class="form-group">
                    <label
                        class="form-control-label text-muted pr-4"
                        for="email"
                        >Send File Approval Notification</label
                    >
                    <input
                        class="form-check-input"
                        type="checkbox"
                        v-model="form.send_file_approval_notification"
                        :checked="form.send_file_approval_notification == 1"
                    />
                </div>
            </div>
        </div> -->
        <div class="row pt-2">
            <div class="col-md-12">
                <div class="form-group">
                    <label class="form-control-label text-muted" for="password"
                        >Password</label
                    >
                    <input
                        type="password"
                        v-model="form.password"
                        id="confirmPassword"
                        name="confirmPassword"
                        class="form-control"
                        :class="{
                            'is-invalid': submitted && v$.form.password.$error,
                        }"
                    />
                    <!-- <span class="text-danger" v-if="v$.form.password.$errors">
                        {{ v$.form.password.$errors[0]?.$message }}
                    </span> -->
                    <p v-if="v$.form.password.$error" class="text-danger m-0">Password must meet the following criteria:</p>
                    <ul v-if="v$.form.password.$errors" class="text-danger">
                        <li v-for="(item, idx) in v$.form.password.$errors" :key="idx">
                            {{ item.$message }}
                        </li>
                    </ul>
                </div>
            </div>
        </div>
        <div class="row pt-2">
            <div class="col-md-12">
                <div class="form-group">
                    <label
                        class="form-control-label text-muted"
                        for="confirm_password"
                        >Confirm Password</label
                    >
                    <input
                        type="password"
                        v-model="form.confirm_password"
                        id="confirmPassword"
                        name="confirmPassword"
                        class="form-control"
                        :class="{
                            'is-invalid':
                                submitted && v$.form.confirm_password.$error,
                        }"
                    />
                    <span
                        class="text-danger"
                        v-if="v$.form.confirm_password.$errors"
                    >
                        {{ v$.form.confirm_password.$errors[0]?.$message }}
                    </span>
                </div>
            </div>
        </div>
        <button
            type="submit"
            class="mt-5 btn btn-outline-orange text-orange text-uppercase float-right"
        >
            {{ modalType == "edit" ? "Update Account" : "Add Account" }}
        </button>
    </form>
</template>

<script>
import { computed } from "vue";
import { useStore } from "vuex";
import { useVuelidate } from "@vuelidate/core";
import {
    required,
    email,
    minLength,
    sameAs,
    requiredIf,
    helpers
} from "@vuelidate/validators";
const { regex, withMessage } = helpers;

export default {
    props: ["modalType", "modalSet", "modalData", "modalSalesRepId"],
    emits: ["closeModal"],
    components: {},
    setup() {
        const store = useStore();

        let user = computed(function () {
            return store.state.user;
        });

        function addSalesRep(form) {
            store.dispatch("salesRep/addSalesRep", form);
        }

        function updateSalesRep(form) {
            store.dispatch("salesRep/updateSalesRep", form);
        }

        return {
            user,
            addSalesRep,
            updateSalesRep,
        };
    },
    data() {
        return {
            v$: useVuelidate(),
            form: {
                id: null,
                first_name: null,
                last_name: null,
                email: null,
                phone: null,
                status: null,
                user_type: null,
                password: null,
                confirm_password: null,
                role: null,
                send_file_approval_notification: false,
            },
            submitted: false,
        };
    },
    validations() {
        return {
            form: {
                first_name: { required },
                last_name: { required },
                email: { required, email },
                phone: { required },
                // password: {
                //     required: requiredIf(function () {
                //         return this.modalType != "edit";
                //     }),
                //     minLength: minLength(10),
                // },
                password: {
                    required: requiredIf(function () {
                        return this.modalType != "edit";
                    }),
                    minLength: withMessage('Password must be at least 10 characters long', minLength(10)),
                    uppercase: withMessage('Password must contain at least 1 uppercase letter', regex(/[A-Z]+/)),
                    lowercase: withMessage('Password must contain at least 1 lowercase letter', regex(/[a-z]+/)),
                    number: withMessage('Password must contain at least 1 number', regex(/\d+/)),
                    symbol: withMessage('Password must contain at least 1 symbol', regex(/[!@#$%^&*(),.?":{}|<>]/)),
                    notCommon: withMessage('The password you entered is too common and can be easily guessed. Please choose a more secure password to increase your account\'s safety', this.isNotCommonPassword),
                },
                confirm_password: {
                    required: requiredIf(function () {
                        return this.modalType != "edit";
                    }),
                    sameAsPassword: sameAs(this.form.password),
                },
                role: { required },
            },
        };
    },
    mounted() {
        this.clearFields();

        if (this.modalType == "edit") {
            this.populateData();
        }
    },
    methods: {
        handleSubmit(e) {
            this.submitted = true;

            this.v$.$validate();
            if (!this.v$.$error) {
                // if ANY fail validation
                this.addorUpdateSalesRep();
            } else {
                // alert('Form failed validation')
            }
        },
        addorUpdateSalesRep() {
            if (this.modalType == "add") {
                this.form.id = null;

                this.addSalesRep(this.form);
            } else {
                this.updateSalesRep(this.form);
            }
            this.$emit("closeModal");
        },
        populateData() {
            this.form.id = this.modalData.id;
            this.form.first_name = this.modalData.first_name;
            this.form.last_name = this.modalData.last_name;
            this.form.email = this.modalData.email;
            this.form.phone = this.modalData.phone;
            this.form.role = this.modalData.role.name;
            this.form.send_file_approval_notification =
                this.modalData.send_file_approval_notification;
        },
        clearFields() {
            this.form.first_name = null;
            this.form.last_name = null;
            this.form.email = null;
            this.form.phone = null;
            this.form.password = null;
            this.form.confirm_password = null;
            this.form.role = null;
            this.form.send_file_approval_notification = false;
        },
        isNotCommonPassword(value) {
            const commonPasswords = [
                'qwertyuiop', '1234567890', 'q1w2e3r4t5', '1q2w3e4r5t', '4815162342', '12345qwert',
                '123456789a', '1234554321', 'Usuckballz1', '1111111111', '123456789q', '1029384756',
                'password123', 'basketball', 'Soso123aljg', '123qweasdzxc', '12345678910', 'manchester',
                '1qaz2wsx3edc', 'q1w2e3r4t5y6', '1123581321', '1q2w3e4r5t6y', 'qwerty12345', '1234512345',
                'Mailcreated5240', '1122334455', 'nuttertools', 'qazwsxedcrfv', 'fuck_inside', '123456qwerty',
                '1234567890q', 'qwerty123456', '5555555555', 'terminator', '9876543210', 'california',
                'enterprise', 'rjirfrgbde', '123456789z', 'poiuytrewq', 'Sojdlg123aljg', 'Translator',
                'fktrcfylhf', 'deepthroat', 'multiplelo', 'christopher', 'undertaker', 'a123456789',
                'motherlode', 'sersolution', 'qwerty1234', 'montgom240', 'salamander', 'qwertyqwerty',
                '1.23457E+11', 'syncmaster', 'aleksandra', 'rjycnfynby', 'tinkerbell', 'motherfucker',
                'ghostrider', 'realmadrid', 'PolniyPizdec0211', '1357924680', '7uGd5HIp2J', 'playstation',
                'leavemealone', 'dragonball', '1234567890a', 'microphone', 'gfhjkmgfhjkm', '1234567891',
                'vSjasnel12', 'strawberry', 'washington', '9293709b13', 'yjdsqgfhjkm', 'qazwsxedc123',
                'fuckinside', 'Good123654', '7894561230', 'harrypotter', 'zxcvbnm123', 'mypassword',
                'alessandro', 'abrakadabra', '7777777777', '123456789s', 'underground', 'ghjcnjgfhjkm',
                'password12', 'anastasiya', 'zxcasdqwe123', 'qwert12345', 'pufunga7782', 'highlander',
                'ghhh47hj7649', 'Password123', 'konstantin', 'intercourse', '9999999999', '2222222222',
                '3333333333', '4444444444', '6666666666', '8888888888', '0'
            ];
            return !commonPasswords.includes(value);
        }
    },
};
</script>
